import type { RadioIconProps } from '@mantine/core'
import { IconCheck } from '@tabler/icons-react'

export function RadioIconCheck(props: RadioIconProps) {
  const mergedStyles = {
    ...props.style,
  }

  // It's crucial to spread the incoming `props` onto the icon so that
  // className and other properties are passed through correctly.
  return <IconCheck {...props} style={mergedStyles} />
}
